<template>
  <div
    class="data-list-container vs-con-loading__container"
    id="order-modifier-list"
    v-if="key_config.order_feature == 1"
  >
    <div
      slot="header"
      class="flex flex-wrap-reverse items-center flex-grow justify-between w-row mb-6"
    >
      <div class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <!-- <vs-dropdown
          vs-trigger-click
          class="cursor-pointer item-per-page-dropdown"
          style="width: 140px"
        >
          <div
            class="px-4 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2">{{filter.title}}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu style="width: 120px;">
            <vs-dropdown-item v-for="(item, i) in filterOptions" :key="i">
              <span class="w-full flex justify-between">
                {{item.title}}
                <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" />
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>-->
        <vs-button
          class="gradient gradient-primary no-shadow add-new-responsive"
          type="filled"
          @click="config.isActive = true"
        >Add new modifier</vs-button>
        <!-- <div class="con-input-search vs-table--search ml-4 search-responsive">
          <input
            type="text"
            class="input-search vs-table--search-input rounded-item border-custom"
            placeholder="Search by name"
          />
          <i class="vs-icon notranslate icon-scale material-icons null">search</i>
        </div> -->
      </div>
    </div>
    <vs-table :data="modifier_list">
      <template slot="thead">
        <vs-th class="w-1/3">Name</vs-th>
        <vs-th class="w-1/6 center-title">Type</vs-th>
        <vs-th class="w-1/4">Modifiers</vs-th>
        <vs-th class="w-1/4 center-title">Action</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="tr.modifier_name">{{ tr.modifier_name }}</vs-td>
          <vs-td class="text-center" :data="tr.type">{{ tr.type }}</vs-td>
          <vs-td :data="tr.details" class="pl-4">
            <span class="break-word" v-for="(detail, i) in tr.details" :key="i">
              <span v-if="i != 0">,</span>
              {{detail.name}}
            </span>
          </vs-td>
          <!-- <vs-td>
            <vs-button @click="applyModifierToItemConfig.isActive = true">Apply To Items</vs-button>
          </vs-td>-->
          <vs-td>
            <vs-row class="flex-center">
              <div class="flex items-center align-center justify-center">
                <!-- <vs-button
                  type="border"
                  size="small"
                  icon-pack="feather"
                  icon="icon-edit"
                  color="primary"
                  class="align-center mr-2"
                  @click="editModifier(tr)"
                ></vs-button>
                <vs-button
                  @click.stop="popupActive=true, getIdMod(tr.id)"
                  type="filled"
                  size="small"
                  icon-pack="feather"
                  icon="icon-trash"
                  color="orange"
                ></vs-button> -->
                <img src="../../assets/images/pen-icon.png" class="pen-icon" @click="editModifier(tr)" />
                <img src="../../assets/images/trash-icon.png" class="ml-5 trash-icon" @click.stop="popupActive=true, getIdMod(tr.id)" />
              </div>
              <vs-popup
                class="holamundo delete-popup"
                title="Delete Item"
                :active.sync="popupActive"
              >
                <div class="text-center">
                  <h3>Do you want to delete item?</h3>
                  <div class="flex flex-wrap items-center align-center p-6 justify-center">
                    <vs-button
                      class="mr-6 align-center delete-responsive"
                      @click="deleteModifier"
                    >Delete</vs-button>
                    <vs-button
                      type="border"
                      color="danger"
                      class="cancel-responsive"
                      @click="popupActive=false"
                    >Cancel</vs-button>
                  </div>
                </div>
              </vs-popup>
            </vs-row>
          </vs-td>
        </vs-tr>
        <!-- <span @click="openDetailModal">open test modal</span> -->
      </template>
    </vs-table>
    <add-modifier
      :config="config"
      @CloseSidebar="config.isActive = false"
      :modifierList="modifier_list"
    ></add-modifier>
    <update-modifier
      :sidebarData="sidebarData"
      :sidebarConfig="sidebarConfig"
      @CloseSibarConfig="sidebarConfig.isActive = false"
      :key="sidebarData_key"
      :modifierList="modifier_list"
    ></update-modifier>
    <apply-modifier-to-item :config="applyModifierToItemConfig"></apply-modifier-to-item>
  </div>
  <div v-else-if="key_config.order_feature == 0">
    <vx-card><h2>This is for Go Check In full version, please contact us for more info at <b>832-968-6668</b></h2></vx-card>
  </div>
  <custom-spinner v-else></custom-spinner>
</template>
<script>
import AddModifer from "../../components/order/AddModifier.vue";
import UpdateModifier from "../../components/order/UpdateModifier";
import ApplyModifierToItem from "../../components/order/ApplyModifierToItem.vue";
export default {
  name: "order-modifier-list",
  components: {
    "add-modifier": AddModifer,
    "update-modifier": UpdateModifier,
    "apply-modifier-to-item": ApplyModifierToItem
  },
  data() {
    return {
      idMod: "",
      popupActive: false,
      filterOptions: [
        { id: 1, title: "All Category", name: "all" },
        { id: 2, title: "New", name: "new" },
        { id: 3, title: "At risk", name: "atrisk" }
      ],
      filter: { id: 1, title: "All Category", name: "all" },
      config: {
        isActive: false
      },
      sidebarConfig: {
        isActive: false
      },
      applyModifierToItemConfig: {
        isActive: false
      },
      sidebarData: {},
      sidebarData_key: 0,
      isOpenLoading: false
    };
  },
  // watch: {
  //   key_config: {
  //     immediate: true,
  //     deep: true,
  //     handler() {
  //       if(this.key_config && this.key_config.order_feature != 0 && this.key_config.order_feature != 1) {
  //         this.openLoadingInDiv();
  //       } else {
  //         this.closeLoading();
  //       }
  //     }
  //   },
  // },
  methods: {
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: 'Get data failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    editModifier(tr) {
      this.sidebarConfig.isActive = true;
      this.sidebarData = tr;
      this.sidebarData_key++;
    },
    openDetailModal() {
      this.$emit("openDetailModal");
    },
    getIdMod(id) {
      this.idMod = id;
    },
    deleteModifier() {
      const obj = {
        id: this.idMod
      };
      this.$store
        .dispatch("modifier/DELETE_MODIFIER", obj)
        .then(() => {
          this.$vs.notify({
            title: "Success",
            text: "Delete Modifier Success",
            color: "success",
            position: "top-right"
          });
        })
        .catch(() => {
          this.$vs.notify({
            title: "Fail",
            text: "Delete Modifier Failed",
            color: "danger",
            position: "top-right"
          });
        });
      this.popupActive = false;
    }
  },
  computed: {
    modifier_list() {
      return this.$store.getters["modifier/modifierList"];
    },
    key_config() {
      return this.$store.getters["auth/config"];
    }
  },
  created() {
    this.$store.dispatch("modifier/GET_MODIFIER_LIST");
  }
};
</script>